import copy from 'clipboard-copy';
import { useState } from 'react';
import styles from './copy-url-button.module.less';
import { SecondaryButton } from '@sb1/ffe-buttons-react';

export const CopyUrlButton = ({ displayText, prettyProjectUrl, trackEventFunction }) => {
    const [linkCopied, setLinkCopied] = useState();

    return (
        <>
            <SecondaryButton
                className={styles.linkCopyButton}
                onClick={() => {
                    copy(prettyProjectUrl);
                    trackEventFunction && trackEventFunction();
                    setLinkCopied(true);
                    setTimeout(() => setLinkCopied(false), 5000);
                }}
            >
                <i className={`fa-regular fa-${linkCopied ? 'check' : 'clipboard'}`} />
                {displayText || prettyProjectUrl.replace('https://', '')}
            </SecondaryButton>
            {linkCopied && <span className={styles.linkCopied}>Lenken er kopiert!</span>}{' '}
        </>
    );
};
